import { DatadogRUM } from '@user-portal/datadog-rum';
import { logger, setupLogger } from '@user-portal/logger';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from 'store/configureStore';

import { ANALYTICS_CAT_ID } from 'constants/oneTrust';

import Sentry from 'services/Sentry/SentryInstance';

import App from './App';
import { ExperimentationWrapper } from './providers';
import reportWebVitals from './reportWebVitals';

setupLogger({
    env: import.meta.env.ENV,
    dataDog: {
        clientToken: import.meta.env.DD_RUM_CLIENT_TOKEN,
        serviceName: import.meta.env.DD_SERVICE_NAME,
        version: import.meta.env.RELEASE_DATE,
        sessionSampleRate: Number(import.meta.env.DD_RUM_SAMPLING_RATE) || 20,
    },
});

Sentry.init();
DatadogRUM.init({
    applicationId: import.meta.env.DD_RUM_APPLICATION_ID,
    clientToken: import.meta.env.DD_RUM_CLIENT_TOKEN,
    serviceName: import.meta.env.DD_SERVICE_NAME,
    env: import.meta.env.ENV,
    version: import.meta.env.RELEASE_DATE,
    trackingConsent: import.meta.env.ENV === 'prod' ? 'not-granted' : 'granted',
    oneTrustAnalyticsCategoryId: ANALYTICS_CAT_ID,
    sessionSampleRate: Number(import.meta.env.DD_RUM_SAMPLING_RATE) || 20,
    replaySampleRate: Number(import.meta.env.DD_SESSIONREPLAY_SAMPLING_RATE) || 0,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
    <Provider store={store}>
        <ExperimentationWrapper>
            <App />
        </ExperimentationWrapper>
    </Provider>
);

reportWebVitals((metric) => {
    logger.info('Web Vitals', {
        name: metric.name,
        value: metric.value,
    });
});
